import firebase from 'firebase/app';
import 'firebase/functions';
import * as environments from '../environments';

function getBaseURL(){
    if (environments.useProduction){
        return "https://us-central1-realtor-rewards.cloudfunctions.net"
    } else {
        return "https://us-central1-realtor-rewards-dev.cloudfunctions.net"
    }
}

export function getAllRealtors(companyID) {
    
    return new Promise((resolve, reject) => {
        
        var cloudfunction = firebase.functions().httpsCallable('allRealtors');
        cloudfunction({
            companyID: companyID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function getPointsForUser(companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('getNotifications');
        cloudfunction({
            companyID: companyID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function getPointsForRealtor(realtorUID, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('getClients');
        cloudfunction({
            companyID: companyID,
            userUID: realtorUID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function addCompnayCodeToUser(code, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('addCompnayCodeToUser');
        cloudfunction({
            companyID: companyID, 
            code: code
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function getUserPoints(endUserUID, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('getClients');
        cloudfunction({
            companyID: companyID, 
            userUID: endUserUID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function getSalesPeople(companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('allSales');
        cloudfunction({
            companyID: companyID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function createHTMLString(htmlObject, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('createHTMLString');
        cloudfunction({
            companyID: companyID,
            regObject: htmlObject
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function createPDFAndSend(htmlstring, newHomeConsultantUID, htmlUID, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('createPDFAndEmail');
        cloudfunction({
            companyID: companyID,
            emailAddressPersonUID: newHomeConsultantUID,
            HTML: htmlstring,
            nodeName: htmlUID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function approvePoints(clientUID, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('approvePoints');
        cloudfunction({
            companyID: companyID,
            clientID: clientUID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function denyPoints(clientUID, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('denyPoints');
        cloudfunction({
            companyID: companyID,
            clientID: clientUID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function deletePoints(clientUID, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('deletePoints');
        cloudfunction({
            companyID: companyID,
            clientID: clientUID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function getManagers(companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('allManagers');
        cloudfunction({
            companyID: companyID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });
            
    });     

}

export function updateUser(userObject, password, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('updateUser');
        cloudfunction({
            companyID: companyID,
            userProfile: userObject,
            password: password
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function clearNotification(notificationUID, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('clearTextNotification');
        cloudfunction({
            companyID: companyID,
            notificationUID: notificationUID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function getNotifications(companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('getTextNotifications');
        cloudfunction({
            companyID: companyID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function createClient(clientRecord, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('createClient');
        cloudfunction({
            companyID: companyID,
            clientName: clientRecord.clientName,
            communityVisited: clientRecord.communityVisited,
            date: clientRecord.formattedDate,
            realtorUID: clientRecord.realtorUID,
            region: clientRecord.region,
            points: clientRecord.points
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function createOnHoldPoints(clientRecord, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('createOnHoldPoints');
        cloudfunction({
            companyID: companyID,
            clientName: clientRecord.clientName,
            communityVisited: clientRecord.communityVisited,
            date: clientRecord.formattedDate,
            realtorEmail: clientRecord.realtorEmail,
            region: clientRecord.region,
            points: clientRecord.points
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function checkCode(code) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('checkCode');
        cloudfunction({
            code: code
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function createAccount(code, password, user) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('createAccount');
        cloudfunction({
            code: code,
            email: user.email,
            password: password,
            firstName: user.firstName,
            lastName: user.lastName,
            phoneNumber: user.phoneNumber,
            region: user.region,
            officeName: user.officeName,
            officeNumber: user.officeNumber,
            officeAddress: user.officeAddress,
            officeCity: user.officeCity,
            officeState: user.officeState,
            officeZip: user.officeZip
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });
            
    });     

}

export function loginAnalytics(companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('loginAnalytics');
        cloudfunction({
            companyID: companyID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function getMySubmittedPoints(companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('getSubmittedPoints');
        cloudfunction({
            companyID: companyID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function resendVerificationEmail(email) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('resendVerifictionEmail');
        cloudfunction({

        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function verifyEmail(code) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('verifyEmail');
        cloudfunction({
            code: code
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function checkPromoCode(code) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('checkPormoCode');
        cloudfunction({
            promoCode: code
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function getEventsForUser(companyID, startDate, endDate, offset){

    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('getEventsForUser');
        cloudfunction({
            companyID,
            startDate,
            endDate,
            offset
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.events)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    }); 

}



//admin requests 

export function updateUserRole(userUID, newRole, companyID) {

    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('updateUserRole');
        cloudfunction({
            companyID: companyID,
            userUID: userUID,
            newRole: newRole
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function getAllUsers(companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('getAllUsers');
        cloudfunction({
            companyID: companyID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function sendTextNotification(title, body, receivingUIDArray, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('sendTextNotification');
        cloudfunction({
            companyID: companyID,
            title: title,
            body: body,
            receivingUIDArray: receivingUIDArray
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function getNotificationAnalytics(companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('getNotificationAnalytics');
        cloudfunction({
            companyID: companyID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

//use only between two realtors 
export function transferPoints(oldUID, newUID, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('transferPoints');
        cloudfunction({
            companyID: companyID,
            newUID: newUID,
            oldUID: oldUID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function addRegion(regionName, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('addRegion');
        cloudfunction({
            companyID: companyID,
            regionName: regionName
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function deleteRegion(regionNodeName, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('deleteRegion');
        cloudfunction({
            companyID: companyID,
            regionNodeName: regionNodeName
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function addCommunity(communityName, region, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('addCommunity');
        cloudfunction({
            companyID: companyID,
            communityName: communityName,
            region: region
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function deleteCommunity(communityNodeName, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('deleteCommunity');
        cloudfunction({
            companyID: companyID,
            communityNodeName: communityNodeName
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function updateCommunity(communityNodeName, communityName, region, companyID){

    return new Promise((resolve, reject) => {

        const payload = {
            community: communityName,
            nodeName: communityNodeName,
            region: region
        }

        var cloudfunction = firebase.functions().httpsCallable('updateCommunity');
        cloudfunction({
            companyID: companyID,
            communityData: payload
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });

}

export function updateRewards(rewardObject, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('updateRewards');
        cloudfunction({
            companyID: companyID,
            newPoints: rewardObject
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });
        
    });     

}

export function removeUserFromCompany(removeUserUID, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('removeUserFromCompany');
        cloudfunction({
            companyID: companyID,
            userUID: removeUserUID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function createCodeAndSend(role, emailAddress, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('createCodeAndSend');
        cloudfunction({
            companyID: companyID,
            role: role,
            emailAddress: emailAddress
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function emailSpreadsheet(startDate, endDate, reportRegion, pointsArray, shouldIncludeBonusLevels, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('emailSpreadsheet');
        cloudfunction({
            companyID: companyID,
            startDate: startDate.format('MM-DD-YYYY'),
            endDate: endDate.format('MM-DD-YYYY'),
            region: reportRegion,
            pointsIncluded: pointsArray,
            shouldIncludeBonusLevels: shouldIncludeBonusLevels
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function updateShouldShowYTD(shouldShowYTD, companyID) {
    
    return new Promise((resolve, reject) => {
        var cloudfunction = firebase.functions().httpsCallable('updateShouldShowYTD');
        cloudfunction({
            companyID: companyID,
            shouldShow: shouldShowYTD
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function getOnHoldPoints(companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('getOnHoldPoints');
        cloudfunction({
            companyID: companyID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function deleteOnHoldPoint(onHoldPointNodeName, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('deleteOnHoldPoint');
        cloudfunction({
            companyID: companyID,
            onHoldPointNodeName: onHoldPointNodeName
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function updateOnHoldPoint(onHoldPointNodeName, companyID, realtorEmail) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('updateOnHoldPoint');
        cloudfunction({
            companyID: companyID,
            onHoldPointNodeName: onHoldPointNodeName,
            realtorEmail: realtorEmail
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function reprocessOnHoldPoint(onHoldPointNodeName, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('reprocessOnHoldPoint');
        cloudfunction({
            companyID: companyID,
            onHoldPointNodeName: onHoldPointNodeName
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function getClientRegistrations(companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('getAllRegistrations');
        cloudfunction({
            companyID: companyID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function resendCientRegistration(homeConsultantUID, nodeName, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('resendRegistration');
        cloudfunction({
            companyID: companyID,
            homeConsultantUID: homeConsultantUID,
            nodeName: nodeName
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function createReward(rewardName, rewardPoint, companyID, mustHaveClient, active) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('createReward');
        cloudfunction({
            companyID: companyID,
            rewardName: rewardName,
            rewardPoint: rewardPoint,
            mustHaveClient: mustHaveClient, 
            activeReward: active
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.newReward)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function deleteReward(rewardNodeName, companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('deleteReward');
        cloudfunction({
            companyID: companyID,
            rewardNodeName: rewardNodeName
        }).then(result => {
            // Read result of the Cloud Function.
            resolve()
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function createCompanyAccount(user, company, promoCode, stripeToken, selectedSchedule){

    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('createCompanyAccount');
        cloudfunction({
            user: user,
            company: company,
            promoCode: promoCode, 
            stripeToken: stripeToken,
            selectedSchedule: selectedSchedule
        }).then(result => {
            // Read result of the Cloud Function.
            resolve()
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    }); 

}

export function updateCompanyAccount(companyID, company, OnHoldReportObject){

    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('updateCompanyAccount');
        cloudfunction({
            companyID: companyID,
            companyColor: company.companyColor,
            companyInfoPDF_URL: company.infoPDF,
            companyRulesPDF_URL: company.rulesPDF,
            OnHoldReortEmailArray: OnHoldReportObject,
            YTDSetting: company.YTDSetting,
            shouldUsePrimaryButtonOnInformationPage: company.shouldUsePrimaryButtonOnInformationPage,
            primaryButtonURL: company.primaryButtonURL,
            shouldUseSecondaryButtonOnInformationPage: company.shouldUseSecondaryButtonOnInformationPage,
            secondaryButtonURL: company.secondaryButtonURL,
            hidePointsFromAdmins: company.hidePointsFromAdmins,
            hidePointsFromManagers: company.hidePointsFromManagers,
            hidePointsFromSales: company.hidePointsFromSales,
            hidePointsFromRealtors: company.hidePointsFromRealtors,
            shouldShowEvents: company.shouldShowEvents
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.company)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    }); 

}

export function updateRegistrationRules(companyID, rules, actingAs, operatingStates){

    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('updateRegistrationRules');
        cloudfunction({
            companyID: companyID,
            rules: rules,
            actingAs: actingAs,
            operatingStates: operatingStates
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.company)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    }); 

}

export function createAutoNotification(companyID, newAutoNotification){

    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('createAutoNotification');
        cloudfunction({
            companyID: companyID,
            autoNotification: newAutoNotification 
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.newAutoNotification)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    }); 

}

export function editAutoNotification(companyID, autoNotification){

    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('editAutoNotification');
        cloudfunction({
            companyID: companyID,
            autoNotification: autoNotification,
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.updatedAutoNotification)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    }); 

}

export function deleteAutoNotification(companyID, autoNotificationID){

    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('deleteAutoNotification');
        cloudfunction({
            companyID: companyID,
            autoNotificationID: autoNotificationID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    }); 

}

export function getAllAutoNotifications(companyID){

    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('getAllAutoNotifications');
        cloudfunction({
            companyID: companyID,
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.autoNotifications)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    }); 

}

export function getAllBonusLevels(companyID){

    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('getAllBonusLevels');
        cloudfunction({
            companyID: companyID,
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    }); 

}

export function updateBonusLevels(companyID, bounsLevels){

    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('updateBonusLevels');
        cloudfunction({
            companyID: companyID,
            bounsLevels: bounsLevels
        }).then(result => {
            // Read result of the Cloud Function.
            resolve()
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    }); 

}

export function updateCompanyUseBonusLevel(companyID, shouldUseBonusLevel, resetBonusLevelsQuarterly){

    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('shouldCompanyUseBonusLevel');
        cloudfunction({
            companyID: companyID,
            shouldUseBonusLevel: shouldUseBonusLevel,
            resetBonusLevelsQuarterly: resetBonusLevelsQuarterly
        }).then(result => {
            // Read result of the Cloud Function.
            resolve()
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    }); 

}

export function createEvents(title, body, receivingUIDArray, companyID, startDate, endDate, colorCode, location) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('createEvent');
        cloudfunction({
            companyID: companyID,
            title: title,
            body: body,
            receivingUIDArray: receivingUIDArray,
            startDate: startDate,
            endDate: endDate,
            colorCode: colorCode,
            location: location
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}

export function getEventAnalytics(companyID) {
    
    return new Promise((resolve, reject) => {

        var cloudfunction = firebase.functions().httpsCallable('getEventAnalytics');
        cloudfunction({
            companyID: companyID
        }).then(result => {
            // Read result of the Cloud Function.
            resolve(result.data.response)
            // ...
        }).catch(error => {
            // Getting the Error details.
            reject(error)
        });

    });     

}


// WEBPACK FOOTER //
// ./src/API/NetworkRequests.js